import Navbar from "../Navbar";

function Layout(props) {
  return (
    <div className="bg-[#0f172a]">
      {/* the Navbar section */}
      <div className="fixed top-0 z-50 w-full">
        <Navbar />
      </div>
      <main className="z-0 mt-[58px]">{props.children}</main>
    </div>
  );
}

export default Layout;
